export default "__VITE_ASSET__BGI7r1$n__"